import { Webgl2 } from "../../../webgl2";
import { Webgl2Component } from "../../webgl2-component";
import { MeasurementComponent } from "./measurement-component";

export class MeasurementsComponent extends Webgl2Component {
  private _measurementHeight = 3;
  private _fontSize = 14;

  // NOTE: this values is taken from design perspective to calc relation aspect values
  private static _PIVOT_SIZE = 1500;
  private static _PIVOT_MEASUREMENT_HEIGHT = 3;
  private static _PIVOT_FONT_SIZE = 40;

  constructor() {
    super();
  }

  public setMeasurementHeightAndFontSize(minCanvasSide: number) {
    const diff = minCanvasSide / MeasurementsComponent._PIVOT_SIZE;

    this._measurementHeight = MeasurementsComponent._PIVOT_MEASUREMENT_HEIGHT * diff;
    this._fontSize = MeasurementsComponent._PIVOT_FONT_SIZE * diff;

    this._children.forEach((component) => {
      if (component instanceof MeasurementComponent) {
        component.setMeasurementSizes(this._measurementHeight, this._fontSize);
      }
    });
  }

  public setChildren(components: MeasurementComponent[]) {
    this._children.clear();
    components.forEach((component) => {
      component.setMeasurementSizes(this._measurementHeight, this._fontSize);
      this._children.add(component);
    });
  }

  public getRenderData() {
    const material = Webgl2.materials.transparent;
    return { material };
  }
}

export default MeasurementsComponent;
